import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';

export function Fullscreen({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & {children?: React.ReactNode}) {
  return (
    <div
      className={twMerge('fixed top-0 left-0 h-full w-full', className)}
      {...props}
    >
      {children}
    </div>
  );
}
